import { makeStyles } from "@material-ui/styles";

const NoDataBoxStyles = makeStyles(() => ({
	noDataBox: {
		width: "100%",
		textAlign: "center",
		border: "1px solid rgba(224, 224, 224, 1)",
		borderRadius: "5px",
		padding: "15px"
	},
	noData: {
		color: "#5B5B5B",
		fontSize: "0.875rem",
		fontFamily: "Roboto",
		fontWeight: 400
	}
}));

export default NoDataBoxStyles;
